import {
  AfterContentInit,
  Component,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { SkyListSecondaryActionsService } from './list-secondary-actions.service';


export class SkyListSecondaryActionComponent implements AfterContentInit {
  
  private templateRef: TemplateRef<any>;

  constructor(
    private actionService: SkyListSecondaryActionsService
  ) { }

  public ngAfterContentInit() {
    this.actionService.addSecondaryAction({
      template: this.templateRef
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-list-secondary-action',
  template: `<ng-template #listSecondaryAction>
  <ng-content></ng-content>
</ng-template>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyListSecondaryActionsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'templateRef': [{ type: ViewChild, args: ['listSecondaryAction', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
